// import Monitor from "../views/monitor/Monitor";
// import MonitorIjinUsaha from "../views/monitor/MonitorIjinUsaha";
// import MonitorKontrak from "../views/monitor/MonitorKontrak";
// import Report from "./../views/monitor/Report.vue";
// import Template from "./../views/monitor/Template.vue"
import Monitor2 from "../views/monitor/Monitor2";
import MonitorIjinUsaha2 from "../views/monitor/MonitorIjinUsaha2";
import MonitorKontrak2 from "../views/monitor/MonitorKontrak2";
import MonitorKontrakDivisi from "../views/monitor/MonitorKontrakDivisi";
import LaporanDashboard from "../views/monitor/LaporanDashboard";
import LaporanRupDanPaketKegiatan from "../views/monitor/LaporanRupDanPaketKegiatan";
import LaporanVendor from "../views/monitor/LaporanVendor";
import LaporanTest from "../views/monitor/LaporanTest";
import LaporanTest2 from "../views/monitor/LaporanTest2";

const monitor = [
    {
        path: '/monitor',
        component: Monitor2,
    },
    {
        path: "/monitor-ijin-usaha",
        component: MonitorIjinUsaha2,
	},
	{
        path: '/monitor-kontrak',
        component: MonitorKontrak2,
    },
    {
        path: '/monitor-kontrak-divisi',
        component: MonitorKontrakDivisi,
    },
	{
        path: '/laporan-dashboard',
        component: LaporanDashboard,
    },
	{
        path: '/laporan-rup-dan-paket-kegiatan',
        component: LaporanRupDanPaketKegiatan,
    },
	{
        path: '/laporan-vendor',
        component: LaporanVendor,
    },
	{
        path: '/laporan-test',
        component: LaporanTest,
    },
	{
        path: '/laporan-test2',
        component: LaporanTest2,
    }
]

export default monitor